module.exports = __webpack_public_path__ + "img/chart-icon.f8758504.svg";